const skillsTypes = {

  get: {
    request: "GET_SKILL_REQUEST",
    success: "GET_SKILL_SUCCESS",
    failure: "GET_SKILL_FAILURE"
  },

  index: {
    request: "SKILLS_INDEX_REQUEST",
    success: "SKILLS_INDEX_SUCCESS",
    failure: "SKILLS_INDEX_FAILURE"
  },

  create: {
    init:    "CREATE_SKILL_INIT",
    request: "CREATE_SKILL_REQUEST",
    success: "CREATE_SKILL_SUCCESS",
    failure: "CREATE_SKILL_FAILURE"
  },

  update: {
    request: "UPDATE_SKILL_REQUEST",
    success: "UPDATE_SKILL_SUCCESS",
    failure: "UPDATE_SKILL_FAILURE"
  },

  destroy: {
    request: "DESTROY_SKILL_REQUEST",
    success: "DESTROY_SKILL_SUCCESS",
    failure: "DESTROY_SKILL_FAILURE"
  },

  set_errors: "SET_SKILL_ERRORS",

  reset: "RESET_SKILL"

}

export default skillsTypes



// WEBPACK FOOTER //
// ./src/js/constants/skillsTypes.js